import React from 'react';
import { Img } from '@chakra-ui/react';
import { Global } from '@emotion/core';
import { TTemplate } from '@/helpers/createTemplate';
import {
  LocationNotAllowedContainer,
  CenterWrapper,
} from '../styles/LocationNotAllowed.styles';
import logo from '../../../assets/vikingbet/images/logo.svg';
import Heading from '../components/Heading';
import PCBody from '../components/PCBody';

const { REACT_APP_THEME_NAME } = window.BETCLOUD_ENV;

const template: TTemplate = {
  wrapper: <LocationNotAllowedContainer />,
  main: {
    wrapper: <CenterWrapper />,
    logo: (
      <Img
        src={logo}
        alt={REACT_APP_THEME_NAME}
        h={['45px', null, '47px']}
        mb={['40', null, '0']}
      />
    ),
    heading: <Heading />,
    desc: <PCBody />,
    body: (
      <Global styles={{ body: { background: 'var(--bc-colors-gray-400)' } }} />
    ),
  },
};

export default template;
